/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Collection_4Inputs */

const en_flow_collection_4 = /** @type {(inputs: Flow_Collection_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The buyer follows the order in Frontrow.`)
};

/**
* | output |
* | --- |
* | "The buyer follows the order in Frontrow." |
*
* @param {Flow_Collection_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_collection_4 = /** @type {((inputs?: Flow_Collection_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Collection_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_collection_4(inputs)
});